const defaultMimeTypes = [
    'text/plain',
    'application/pdf',
    'image/*',
    'video/*',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export default defaultMimeTypes.join();
